import { cloneElement, forwardRef, memo } from 'react';

import { OptionalWrapperProps } from './OptionalWraper.types';

export const OptionalWrapper = memo(
  forwardRef<HTMLDivElement, OptionalWrapperProps>(({ wrapper, withoutWrapper, children, ...rest }, ref) => {
    if (withoutWrapper) {
      return children;
    }

    return wrapper ? (
      cloneElement(wrapper, { children })
    ) : (
      <div ref={ref} {...rest}>
        {children}
      </div>
    );
  }),
);
